import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useJobsCandidatesState = (propsOrData, options = {}) => {
  // Support passing either appliedJobdata directly or an options object { appliedJobdata, itemsPerPage }
  const appliedJobdata = Array.isArray(propsOrData)
    ? propsOrData
    : propsOrData?.appliedJobdata;

  const itemsPerPage =
    (typeof propsOrData === "object" &&
      !Array.isArray(propsOrData) &&
      propsOrData?.itemsPerPage) ||
    options?.itemsPerPage ||
    50;

  const [lgShow, setLgShow] = useState(false);
  const [coverletter, setCoverletter] = useState("");
  const [cvdata, setCvdata] = useState("");
  const location = useLocation();

  // Search and Filter states
  const [searchText, setSearchText] = useState("");
  const [selectedJobId, setSelectedJobId] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);

  // Set default data when API data changes
  useEffect(() => {
    setFilteredData(appliedJobdata || []);
  }, [appliedJobdata]);

  // Real-time Search & Filter Logic
  useEffect(() => {
    let filtered = appliedJobdata || [];

    if (selectedJobId) {
      filtered = filtered.filter((item) => {
        // Handle cases where jobid is populated as an object or just a string ID
        const currentJobId = item?.jobid?._id || item?.jobid;
        return currentJobId === selectedJobId;
      });
    }

    if (searchText.trim()) {
      filtered = filtered.filter(
        (item) =>
          item?.name?.toLowerCase().includes(searchText.toLowerCase()) ||
          item?.designation?.toLowerCase().includes(searchText.toLowerCase()),
      );
    }

    setFilteredData(filtered);
    setCurrentPage(1);
  }, [searchText, selectedJobId, appliedJobdata]);

  // Pagination calculations
  const totalItems = filteredData?.length || 0;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData?.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 0);
  };

  const handleViewCandidate = (candidate) => {
    setLgShow(true);
    setCoverletter(candidate?.coverletter || "");
    setCvdata(candidate?.cv?.[0] || "");
  };

  const handleCloseModal = () => {
    setLgShow(false);
  };

  return {
    lgShow,
    setLgShow,
    coverletter,
    setCoverletter,
    cvdata,
    setCvdata,
    location,
    searchText,
    setSearchText,
    selectedJobId,
    setSelectedJobId,
    filteredData,
    setFilteredData,
    currentPage,
    setCurrentPage,
    itemsPerPage,
    totalItems,
    totalPages,
    indexOfLastItem,
    indexOfFirstItem,
    currentItems,
    handlePageChange,
    handleViewCandidate,
    handleCloseModal,
  };
};

export const useJobapplyCandidatesState = useJobsCandidatesState;
export const useJobapplyCandidates = useJobsCandidatesState;
export default useJobsCandidatesState;
